import { APP_CONFIG } from '../config.js';

export default {
    /*
    GET /api/albums/{id}/
    To get album information
    */
    getAlbum: function(albumId) {
        return axios.get(APP_CONFIG.API_URL + '/albums/' + albumId);
    },

    /*
    GET /api/albums
    To get list of albums information
    */
    getAlbums: function(page = 1, perPage = 25) {
        return axios.get(APP_CONFIG.API_URL + '/albums?page=' + page + '&per_page=' + perPage);
    },

    /*
    GET /api/albums/list
    To get list of all albums
    */
    getAlbumList: function() {
        return axios.get(APP_CONFIG.API_URL + '/albums/list');
    },

    /*
    DELETE /api/albums/{id}/delete
    To delete an album
    */
    deleteAlbum: function(albumId) {
        return axios.delete(APP_CONFIG.API_URL + '/albums/' + albumId);
    },

    /*
    POST /api/albums/collection:batchDelete
    To delete a selected collection of albums
    */
    deleteAlbums: function(albumIdsSeq) {
        return axios.post(APP_CONFIG.API_URL + '/albums/collection:batchDelete',
        {
            ids: albumIdsSeq,
        });
    },

    /*
    POST /api/albums/{id}/
    To edit an album
    */
    editAlbum: function(id, originalTitle, romajiTitle, englishTitle, description, type, cover_art, number_of_tracks, composer, yearOfRelease) {
        let formData = new FormData();
        formData.append('cover_art', cover_art)
        formData.append('original_title', originalTitle)
        formData.append('romaji_title', romajiTitle)
        formData.append('english_title', englishTitle)
        formData.append('description', description)
        formData.append('type', type)
        formData.append('number_of_tracks', number_of_tracks)
        formData.append('composer', composer)
        formData.append('year_of_release', yearOfRelease)
        return axios.post(APP_CONFIG.API_URL + '/albums/' + id,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*'
            }
        });
    },

    /*
    POST /api/albums/
    To create a new album
    */
    createAlbum: function(originalTitle, romajiTitle, englishTitle, description, type, coverArt, numberOfTracks, composer, yearOfRelease) {
        let formData = new FormData();
        formData.append('cover_art', coverArt)
        formData.append('original_title', originalTitle)
        formData.append('romaji_title', romajiTitle)
        formData.append('english_title', englishTitle)
        formData.append('description', description)
        formData.append('type', type)
        formData.append('number_of_tracks', numberOfTracks)
        formData.append('composer', composer)
        formData.append('year_of_release', yearOfRelease)
        return axios.post(APP_CONFIG.API_URL + '/albums',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*'
            }
        });
    },

    /*
    POST /api/albums/check_exist
    Check if the album already exists
    */
    checkExist: function(albumTitle, yearOfRelease) {
        return axios.post(APP_CONFIG.API_URL + '/albums/check_exist',
        {
            album_title: albumTitle,
            year_of_release: yearOfRelease,
        });
    },

    /*
    Get /api/albums/added_album_stats
    To get album stats
    */
    getAlbumStats: function() {
        return axios.get(APP_CONFIG.API_URL + '/albums/added_album_stats');
    },

    /*
    Get /api/albums/most_recent
    To get most recent album list
    */
    getMostRecentAlbumList: function(page, perPage) {
        return axios.get(APP_CONFIG.API_URL + '/albums/most_recent?page=' + page + '&per_page=' + perPage);
    },
}
